<template>
    <tr style="background: #fafafa">
        <td></td>
<!--LEFT-->
        <td :colspan="colspan">
            <budget-order-detail :data="row.left" @updated="$emit('updated')"/>
        </td>

<!--CENTER-->
        <td class="table-separator">
        </td>

<!--RIGHT-->
        <td :colspan="colspan" class="table-separator" v-if="!row.right.is_locked">
            <budget-order-detail :data="row.right" @updated="$emit('updated')"/>
        </td>
        <td :colspan="colspan" class="table-separator" v-if="row.right.is_locked" style="text-align: center;">
            <h2>Locked</h2>
            <div>Budget setting will carry over</div>
        </td>
        <td></td>
    </tr>
</template>

<script>
import BudgetOrderDetail from "./budget-order-detail";

export default {
    components: {BudgetOrderDetail},
    props: [
        'row', 'colspan'
    ]
}
</script>
